import React from 'react'

import SelectFieldInner from './Inners/SelectField'
import TextFieldInner from './Inners/TextField'
import NumberFieldInner from './Inners/NumberField'
import TextareaFieldInner from './Inners/TextareaField'
import DateFieldInner from './Inners/DateField'
import TimeFieldInner from './Inners/TimeField'
import CheckboxFieldInner from './Inners/CheckboxField'
import SwitchFieldInner from './Inners/SwitchField'
import RadioFieldInner from './Inners/RadioField'

import SelectField from 'championship/src/classes/form/fields/select'
import TextField from 'championship/src/classes/form/fields/text'
// import NumberField from 'championship/src/classes/form/fields/number'
import DateField from 'championship/src/classes/form/fields/date'
import TimeField from 'championship/src/classes/form/fields/time'
import CheckboxField from 'championship/src/classes/form/fields/checkbox'
import SwitchField from 'championship/src/classes/form/fields/switch'
import RadioField from 'championship/src/classes/form/fields/radio'

// import SelectFieldAtomAdapter from './AtomAdapters/SelectField'
// import CheckboxFieldAtomAdapter from './AtomAdapters/CheckboxField'
import DefaultAdapter from './AtomAdapters/Default'
// import SelectFieldAdapter from './AtomAdapters/SelectField'

import { initialSchemaAtom, modelStore, getModel } from '../TournamentForm/model'

const components = {
    select: {
        inner: SelectFieldInner,
        handler: SelectField,
        // adapter: SelectFieldAdapter,
        adapter: DefaultAdapter,
    },
    text: {
        inner: TextFieldInner,
        handler: TextField,
        adapter: DefaultAdapter,
    },
    number: {
        inner: NumberFieldInner,
        handler: TextField,
        adapter: DefaultAdapter,
    },
    textarea: {
        inner: TextareaFieldInner,
        handler: TextField,
        adapter: DefaultAdapter,
    },
    default: {
        inner: TextareaFieldInner,
        handler: TextField,
        adapter: DefaultAdapter,
    },
    date: {
        inner: DateFieldInner,
        handler: DateField,
        adapter: DefaultAdapter,
    },
    time: {
        inner: TimeFieldInner,
        handler: TimeField,
        adapter: DefaultAdapter,
    },
    checkbox: {
        inner: CheckboxFieldInner,
        handler: CheckboxField,
        // adapter: CheckboxFieldAtomAdapter,
        adapter: DefaultAdapter,
    },
    switch: {
        inner: SwitchFieldInner,
        handler: SwitchField,
        // adapter: CheckboxFieldAtomAdapter,
        adapter: DefaultAdapter,
    },
    radio: {
        inner: RadioFieldInner,
        handler: RadioField,
        // handler: SwitchField,
        adapter: DefaultAdapter,
    }
}


class Field extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            errors: [],
            active: false,

            // _atom_value: 'unset'
        }

        this.unsubscribes = []

        this.interceptArgs()

        this._props = new Proxy(this, {
            get(_that, prop) { 
                // return target.getProp(prop)
                return _that.props?.[prop] 
                    ?? _that.args?.[prop]
            }
        })

        // if(this._props.atom){
        //     this._props.ctx.subscribe(this._props.atom, (value) => {
        //         this.setState({
        //             _atom_value: value
        //         })
        //     })
        // }

        this.root_node_ref = React.createRef()
    }
    interceptArgs(){
        this.args = Object.assign({}, this.props)
    }
    componentWillUnmount(){
        for(const unsubscribe of this.unsubscribes){
            unsubscribe()
        }
        if(this.adapter){
            this.adapter.unsubscribe()
        }
    }
    componentDidMount(){

        if(this._props.__errors){
            return
        }       

        // console.log(this.args, this.args.type)
        const handler_class = components[this.args.type].handler
        if(handler_class){
            this.handler = new handler_class(
                this.root_node_ref.current,
                {
                    mask_installer: this.args?.mask_installer
                }
            )
        }
        // if(this.handler.name == 'type_game'){
            // console.log(`componentDidMount ${this.handler.name} START`, this.handler.getValue())
        // }
        // console.log('this.props.ctx && this.props.atom', this.args.label, this.props.ctx, this.props.atom)
        // if(this.getProp('atom') && this.getProp('atom')){
        // console.log('before before adapter', this._props.name, this._props.type)

        // if(
        //     this._props.ctx 
        //     && (this._props.atom 
        //         || (this._props.onAtomChange
        //             && this._props.onHandlerChange)
        // )){

        // if([
        //     this._props.onChanged, 
        //     this._props.atom, 
        //     this._props.onHandlerChange
        // ].filter((value) => value) !== 1){
        //     // this.fail('either atom or onChanged or actionAtom can be used')
        //     this.fail('only one of _atom, onChanged, actionAtom can be used')
        // }
        
        // console.log('init')
        // console.log([
        //     this._props.onChanged, 
        //     this._props.atom, 
        //     this._props.onHandlerChange
        // ].filter((value) => !!value))

        if(
            !this._props.__errors 
            && ( 
                this._props.ctx 
                && (
                    this._props.atom 
                    || this._props.actionAtom
                )
                || this._props.onChanged
            )
        ){
            const adapter_class = components[this._props.type].adapter
            if(adapter_class){
                this.adapter = new adapter_class({
                    ctx: this._props.ctx,
                    atom: this._props.atom,
                    handler: this.handler,
                    actionAtom: this._props.actionAtom,
                    onAtomChange: this._props.onAtomChange,
                    onHandlerChange: this._props.onHandlerChange,
                    build_atom: this._props?.build_atom,
                    onBuildAtomChange: this._props?.onBuildAtomChange,
                    onChanged: this._props?.onChanged,
                })
            }
            // this.setState({
            //     _atom_value: this._props.ctx.get(this._props.atom)
            // })
        }else{
            this.fail('could not initialize adapter')
        }

        // if(this.handler.name == 'type_game'){
            // console.log(`componentDidMount ${this.handler.name} END`, this.handler.getValue())
        // }

        if(this._props.onMounted){
            this._props.onMounted(this.adapter)
        }
    }
    getProp(prop_name){
        return this.props?.[prop_name] ?? this.args?.[prop_name]
    }
    render(){
        if(this._props.__errors){
            return (
                <div style={{color: '#f00'}}>
                    Ошибка при инициализации поля
                </div>
            )
        }
        const Inner = components[this._props.type].inner
        let need_external_label = this._props.need_external_label
        // console.log('need_external_label', need_external_label)
        if(need_external_label === undefined || need_external_label === null){
            need_external_label = ['checkbox', 'switch', 'radio']
                                    .includes(this.getProp('type')) 
                                    ? false : true
        }

        return (
            <div className={
                `base-form-field ${this._props.disabled ? '-disabled' : ''}`
            }>
                {need_external_label && (
                    <label class="form__label" htmlFor={this._props.id}>
                        {this._props.label}
                        <span> </span>
                        {this._props.required && (
                            <span class="chart-red">*</span>
                        )}
                    </label>
                )}
                <div 
                    ref={this.root_node_ref} 
                    className={`
                        form__field
                        js-form-field 
                        js-form-field--type-${this._props.type}
                        ${(this._props.type == 'checkbox' ? '-checkbox' : '')}
                        ${(this._props.type == 'switch' ? '-checkbox -switch' : '')}
                        ${(this.state.errors.length > 0 ? 'has--errors' : '')}
                        ${(this.state.active > 0 ? 'is--active' : '')}
                        ${this._props.disabled ? 'is--disabled' : ''}
                    `}
                    data-name={this._props.name}
                    data-type={this._props.type}
                >
                    <Inner
                        name={this._props.name}
                        id={this._props.id}
                        {...this.args}
                        // value={this.props.value ? this.props.value : undefined}
                        // value={this.props.value}
                        />
                    <div class="js-form-field__errors">
                        {this.state.errors.map((error, i) => (
                            <div key={i}>
                                {error.text}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
    fail(message){
        console.error(message)
        this.args.__errors = true
    }
    warn(message){
        console.warn(message)
    }
}

export default Field


export class DjangoField extends Field{
    interceptArgs(){
        this.args = {}
        let source
        if(this.props.model){
            // const model = modelStore[this.props.model]
            const model = getModel(this.props.model)
            if(!model){
                this.fail('model is not found')
                return
            }

            // console.log('model.schema', model)
            if(model.validation?.required !== undefined){
                this.args.required = model.validation.required
            }

            if(typeof model.validation?.mask == 'function'){
                this.args.mask_installer = model.validation?.mask
            }else if(model.validation?.mask){
                this.warn('mask cannot be istalled')
            }

            if(model.messages_atom){
                // const that = 
                const unsubscribe = this.props.ctx.subscribe(model.messages_atom, (value) => {
                    // console.log('FIELD', this.props.model, value)
                    this.setState({
                        errors: value
                    })
                })
                this.unsubscribes.push(unsubscribe)
            }
            
            // console.log('this.props.model', this.props.model, model, modelStore)
            
            source = model.schema
            this.args.atom = model.atom
        }else{
            source = this.props.src
        }
        if(source){
            this.args.name = source?.name ?? ''
            this.args.id = source?.id ?? ''

            this.args.required = 
                this.props.required 
                ?? this.args.required 
                ?? source?.required 
                ?? false

            this.args.label = source?.label ?? ''
            this.args.initial_value = source?.initial_value ?? ''

            this.args.min = source?.min_value ?? null
            this.args.max = source?.max_value ?? null

            this.args.type = {
                'BooleanField': 'switch',
                'IntegerField': 'number',
                'CharField': 'text',
                'DateField': 'date',
                'TimeField': 'time',
                'ModelMultipleChoiceField': 'select',
                'TypedChoiceField': 'select',
                'ChoiceField': 'select',
            }?.[source.type] ?? 'text'

            if(this.args.type == 'select'){
                this.args.items = source?.choices ?? []
            }

            const widget = source?.widget
            if(widget){
                this.args.placeholder = widget?.attrs?.placeholder
            }
        }
        Object.assign(this.args, this.props)
    }
}



/* 
<Field 
required={true}
type="switch"
name="single_stage"
id="single_stage"
label="Игра за 3 место"
ctx={ctx}
atom={isSingleAtom}
> */